import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CursosService } from '../services/cursos.service';
import { Curso } from '@/app/models/interface/curso.model';

export const cursoResolver: ResolveFn<Curso> = (route, state) => {
  const service = inject(CursosService);

  const id = route.paramMap.get('id');

  return service.findOne(id ? id : '');
};
